import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";
import { VscThreeBars } from "react-icons/vsc";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { FiExternalLink } from "react-icons/fi";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { HiUser, HiOutlineLogout } from "react-icons/hi";
import { Modal } from "react-bootstrap";
import AppContext from "../../context/AppContext";
import ApiService from "../../api/ApiService";
import notification from "../../helpers/notification";
import { RiLiveFill } from "react-icons/ri";
import axios from "axios";
import CryptoJS from "crypto-js";

const expiry = process.env.REACT_APP_OTPEXPIRY;
let timer = null;

const TopHeader = ({ setOpened }) => {
  const { loginPopup, setLoginPopup, token, setToken, user, donor, setDonor } =
    useContext(AppContext);

  const [isScroll, setIsScroll] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const updateOnScroll = () =>
    window.addEventListener("scroll", () =>
      window.scrollY > 20 ? setIsScroll(true) : setIsScroll(false)
    );

  useEffect(() => {
    updateOnScroll();
  }, []);

  const [otpSent, setOtpSent] = useState(false);
  const [number, setNumber] = useState("");

  const [otp, setOtp] = useState("");

  const [otpExp, setOtpExp] = useState(expiry);
  const [resendtimes, setResendTimes] = useState(0);
  const [showresendlink, setShowResendLink] = useState(false);
  const [isWatchLive, setIsWatchLive] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [seticsmob, SetIcsmob] = useState([]);

  const hasWatchLive = async () => {
    const { liveVideos } = await ApiService.hasWatchLive();
    setIsWatchLive(liveVideos);
  };

  // if(showresendlink){
  //   navigate("/donation-form")
  //   setLoginPopup(false)
  //   setShowResendLink(false)
  // }
  //console.log(resendtimes)
  if (resendtimes == 2) {
    navigate("/donation-form");
    setResendTimes(0);
    setLoginPopup(false);
    setShowResendLink(false);
    setOtpSent(false);
  }

  function getTime(time) {
    return (
      Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2)
    );
  }

  const logOut = () => {
    localStorage.removeItem("token");
    setToken(null);
    navigate("/");
    localStorage.removeItem("icsmob");
    localStorage.removeItem("ics_mob");
    localStorage.removeItem("ics_id");
    localStorage.removeItem("multiplesevatype");
    localStorage.removeItem("multiplesevaPrice");
    localStorage.removeItem("multiplesevaName");
    localStorage.removeItem("ics_number");
    localStorage.removeItem("dms_id");

    localStorage.removeItem("ics_all_data");
  };

  // const settingDefault = async (number) => {
  //   const data = {
  //     phone: number,
  //     donor_id: localStorage.getItem('dms_id'),
  //   }

  //   const response = await ApiService.fetchDonor(data);
  //   console.log(response)

  //   const encryptedData = CryptoJS.AES.encrypt(response.profiles[0]?.phone, process.env.REACT_APP_CSCKEY).toString();

  //   // localStorage.setItem('ics_id', response.profiles[0]?.id);
  //   // localStorage.setItem('ics_name', response.profiles[0]?.legal_name);
  //   localStorage.setItem('ics_number', encryptedData);
  //   window.location.reload(true);
  // }

  const handleSendOtp = async (resend = false) => {
    const getmob = localStorage.getItem("icsmob");
    if (getmob) {
      setNumber(localStorage.getItem("icsmob"));
    }

    if (timer) {
      clearInterval(timer);
    }
    if (number.length >= 10) {
      try {
        setBtnDisabled(true);
        const res = await ApiService.sendOtp({ number, resend });
        notification("success", res.message);
        setBtnDisabled(false);
        timer = setInterval(() => {
          setOtpExp((prev) => prev - 1);
        }, 1000);

        setOtpSent(true);
      } catch (err) {
        console.log(err);
        if (err.response.status === 400) {
          notification("warning", err.response.data.message);
        } else {
          if (
            err.response.data.message ==
            "No donation found for the given mobile number!"
          ) {
            navigate("/donation-form");
            setLoginPopup(false);
            notification("error", err.response.data.message);
          } else {
            notification("error", err.response.data.message);
            navigate("/donation-form");
            setLoginPopup(false);
          }
        }
        setBtnDisabled(false);
      }
    } else {
      notification("warning", "Please Enter Valid Number");
      setBtnDisabled(false);
    }
  };

  const handleLogin = async () => {
    if (otp.length >= 6) {
      try {
        let data = {
          number,
          otp,
        };

        const res = await ApiService.loginUser(data);
        // console.log("res.success", res.success)

        if (res.success) {
          localStorage.setItem("dms_id", res?.user?.dmsDonorId);
          localStorage.setItem(`token`, res.token);
          setToken(res.token);
          setLoginPopup(false);
          notification("success", res.name + " " + res.message);
          navigate("/dashboard");
          setOtpSent(false);
          setOtp("");
        }
      } catch (err) {
        // console.log(err);
        notification("error", err?.response?.data?.message);
        navigate("/donation-form");
      }
    } else {
      notification("warning", "Please Enter Valid OTP");
    }
  };

  function setCookie(name, value) {
    let expires = "";
    let date = new Date();
    date.setTime(date.getTime() + 1 * 60 * 1000);
    expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  const resendOtp = () => {
    setShowResendLink(false);

    if (getCookie("limitReached2")) {
      notification("warning", "Resend OTP limit has been reached!");
      setResendTimes(0);
      setShowTimer(false);
    } else {
      if (resendtimes < 2) {
        setOtpExp(expiry);
        handleSendOtp(true);
        setResendTimes((prev) => prev + 1);
      } else {
        setCookie("limitReached2", true);
        notification("warning", "Resend OTP limit has been reached!");
        setShowTimer(false);
      }
    }
  };

  const handleNavigate = () => {
    navigate("/donate");

    // setTimeout(() => {

    //   const scrollToDonateFromRef = document.getElementById('scrollToDonateFrom3ndPage');

    //   if (scrollToDonateFromRef) {
    //     const offset = -600;
    //     const targetScrollTop = scrollToDonateFromRef.offsetTop - offset;

    //     const container = document.documentElement;

    //     container.scrollTop = targetScrollTop;
    //   } else {
    //     console.error("Element scrollToDonateFromRef not found!");
    //   }
    // }, 1000);

    // window.location.reload();
  };

  const handleHideModal = () => {
    setLoginPopup(false);
  };

  useEffect(() => {
    hasWatchLive();
    setNumber(localStorage.getItem("icsmob"));
  }, []);

  useEffect(() => {
    if (otpExp === 0) {
      setShowResendLink(true);
      clearInterval(timer);
      setOtpExp(expiry);
    }
  }, [otpExp, expiry]);

  const quickDonateBtn = () => {
    localStorage.removeItem("SpecialOccassionAmount");
    localStorage.removeItem("responseData");
    navigate("/donation-form");
    // setTimeout(() => {

    //   const scrollToDonateFromRef = document.getElementById('scrollToDonateFrom');

    //   if (scrollToDonateFromRef) {
    //     const offset = -600;
    //     const targetScrollTop = scrollToDonateFromRef.offsetTop - offset;

    //     const container = document.documentElement;

    //     container.scrollTop = targetScrollTop;
    //   } else {
    //     console.error("Element scrollToDonateFromRef not found!");
    //   }
    // }, 1000);
    localStorage.removeItem("multiplesevatype");

    localStorage.removeItem("multiplesevaPrice");

    localStorage.removeItem("multiplesevaName");
  };

  return (
    <>
      <header className={isScroll ? "scroll" : ""}>
        <div className="w-100%">
          <div
            className="row m-0 align-items-center justify-content-between"
            style={{ background: "#FFFFFF" }}
          >
            <div className="d-flex align-items-center gap-4 p-2 col-auto">
              <div className="d-flex align-items-center gap-2 top-main-head">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <circle cx="6" cy="6" r="6" fill="#F9EACA" />
                  <circle cx="6" cy="6" r="4" fill="#FFC84F" />
                </svg>
                <p
                  className="mb-0"
                  style={{
                    color: "#758497",
                    fontSize: "13px",
                    fontFamily: "Instrument Sans",
                  }}
                >
                  Vijaya Ekadasi
                </p>
              </div>
              <p
                className="mb-0"
                style={{
                  color: "#758497",
                  fontSize: "13px",
                  fontFamily: "Instrument Sans",
                }}
              >
                Daily Darshan
              </p>
              <p
                className="mb-0"
                style={{
                  color: "#758497",
                  fontSize: "13px",
                  fontFamily: "Instrument Sans",
                }}
              >
                04:10 - 13:00 (Temple Open)
              </p>
            </div>

            <div
              className="d-flex align-items-center justify-content-end gap-4 col-auto px-3 py-2"
              style={{
                backgroundColor: "#AA3236",
                borderBottomLeftRadius: "10px",
              }}
            >
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div className="d-flex" style={{ marginRight: "100px" }}>
                  <div
                    className="d-flex align-items-center gap-2 px-3 py-2"
                    onClick={quickDonateBtn}
                  >
                    <svg
                      width="24"
                      height="18"
                      viewBox="0 0 24 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.7419 0.092834C11.5631 0.431401 10.8351 1.6754 11.032 3.01472C11.2381 4.41687 12.1484 5.79172 13.7692 7.14886C14.3096 7.60138 15.892 8.74822 15.976 8.74822C16.0611 8.74822 17.3856 7.79926 18.0389 7.27023C20.8194 5.01823 21.7293 2.37214 20.2786 0.757032C19.141 -0.509388 17.3392 -0.150297 16.2467 1.56047C16.1049 1.78256 15.9836 1.96424 15.9771 1.96424C15.9706 1.96424 15.8648 1.80257 15.7421 1.60491C14.9579 0.342289 13.8383 -0.221989 12.7419 0.092834ZM22.0504 8.16778C21.6985 8.33813 21.124 8.79065 20.1515 9.66348C19.3493 10.3833 18.584 10.9841 18.3697 11.0618C18.3122 11.0828 18.3167 11.1126 18.3908 11.1997C18.9721 11.8831 18.5675 12.8961 17.5546 13.2936C16.9996 13.5114 16.7347 13.4995 14.901 13.1749C12.432 12.738 11.9948 12.7185 11.1587 13.0081C10.7896 13.136 10.6499 13.1034 10.6499 12.8895C10.6499 12.6642 11.077 12.4755 11.8369 12.3651C12.4208 12.2803 12.7741 12.3184 14.901 12.6955C16.5157 12.9818 16.7271 13.0076 17.0143 12.9538C18.2165 12.7284 18.6237 11.7187 17.6999 11.254C17.5073 11.1572 17.0134 11.0325 16.1983 10.875C14.0573 10.4613 13.0689 10.17 11.6713 9.54074C8.67607 8.19222 6.60085 8.38344 4.51161 10.2004C3.99117 10.6531 3.79849 10.7934 3.42826 10.9893L3.09216 11.1672L3.19247 11.4094C3.32961 11.7403 4.93545 15.5237 5.01909 15.7129L5.08627 15.8648L5.64597 15.6053C7.46072 14.7639 7.7213 14.7672 10.7713 15.6704C13.4529 16.4645 13.5156 16.4787 14.3489 16.4752C15.2769 16.4715 15.3625 16.4378 17.5926 15.1997C18.6173 14.6308 19.7537 14.0028 20.1181 13.8042C21.3295 13.1437 21.3152 13.1587 22.8458 10.9304C24.0245 9.21441 24.0953 9.0689 23.9387 8.68366C23.812 8.37148 23.6524 8.25994 23.3282 8.25678C23.1718 8.25523 22.9648 8.21004 22.8675 8.15617C22.6384 8.02929 22.3272 8.03371 22.0504 8.16778ZM1.15993 11.0784C0.540658 11.2816 0.0204321 11.4619 0.00392486 11.4791C-0.0125824 11.4963 0.0245173 11.6327 0.0863504 11.7822C0.383315 12.4996 2.66258 17.8728 2.70653 17.9589C2.75086 18.0458 2.82904 18.0133 3.37703 17.6801C3.71822 17.4726 4.21321 17.1754 4.477 17.0196L4.95665 16.7362L4.69292 16.1198C4.54788 15.7809 3.97195 14.4233 3.41314 13.1032C2.85426 11.7831 2.37202 10.7043 2.34144 10.706C2.31091 10.7076 1.7792 10.8752 1.15993 11.0784Z"
                        fill="#FFC84F"
                      />
                    </svg>

                    <p
                      className="mb-0"
                      style={{
                        fontSize: "14px",
                        color: "#FFC84F",
                        fontFamily: "Instrument Sans",
                        cursor:"pointer"
                      }}
                    >
                      Quick Donate
                    </p>
                  </div>
                  <div
                    className="d-flex align-items-center gap-2 px-3 py-2"
                    onClick={() => {
                      if (token) {
                        logOut(); // Call your logout function
                      } else {
                        setLoginPopup(true); // Show login popup
                      }
                    }}
                    style={{ cursor: "pointer" }} // optional for better UX
                  >
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.50493 9.74463C12.3636 9.728 13.9026 8.18425 13.9557 5.25508C13.9066 2.43675 12.2845 0.810667 9.49543 0.792459C6.6763 0.809875 5.04468 2.47238 5.04468 5.28279C5.04468 8.09321 6.67709 9.728 9.50493 9.74463Z"
                        fill="#FFC84F"
                      />
                      <path
                        d="M9.49544 10.6946C5.27744 10.7215 3.00773 12.9992 2.93173 17.2829C2.92856 17.495 3.0101 17.7001 3.15894 17.8513C3.30777 18.0025 3.51123 18.088 3.7234 18.088H15.2778C15.4899 18.088 15.6934 18.0025 15.8422 17.8513C15.9911 17.7001 16.0726 17.495 16.0694 17.2829C15.9966 13.0609 13.6659 10.7215 9.49544 10.6946Z"
                        fill="#FFC84F"
                      />
                    </svg>

                    <p
                      className="mb-0"
                      style={{
                        fontSize: "14px",
                        color: "#FFC84F",
                        fontFamily: "Instrument Sans",
                      }}
                    >
                      {token ? "Logout" : "Login"}
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-4">
                  <a
                    href="https://www.instagram.com/iskconbhiwandi"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      className=""
                      style={{
                        backgroundColor: "#B63C40",
                        width: "32px",
                        height: "32px",
                        borderRadius: "16px",
                        display: "flex",
                        justifyContent: "center", // center horizontally
                        alignItems: "center", // center vertically
                      }}
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.1696 0.0350078C1.58039 0.304334 0.330932 1.53289 0.0577074 3.09499C-0.0192358 3.5349 -0.0192358 11.4696 0.0577074 11.9095C0.281712 13.1902 1.17657 14.2797 2.39844 14.7592C3.0129 15.0004 2.66305 14.9835 7.32394 14.9968C10.3056 15.0053 11.61 14.9972 11.8097 14.9691C13.3594 14.7512 14.6699 13.4732 14.9412 11.9152C15.0198 11.464 15.0195 3.5386 14.9409 3.08717C14.6744 1.5573 13.436 0.320149 11.9018 0.0511405C11.5768 -0.00585255 3.4988 -0.0207525 3.1696 0.0350078ZM11.2292 2.76592C10.4906 3.09784 10.7023 4.19843 11.5057 4.20375C12.0784 4.20752 12.4361 3.62008 12.173 3.10806C12.0087 2.7885 11.5494 2.62199 11.2292 2.76592ZM7.02489 3.7714C5.04903 4.00434 3.54545 5.89832 3.76755 7.87448C4.11628 10.9773 7.80864 12.3689 10.0535 10.2435C12.6937 7.74376 10.6357 3.34568 7.02489 3.7714ZM7.02489 5.30595C5.63826 5.60057 4.86541 7.14259 5.45714 8.43406C6.25528 10.1761 8.74442 10.1761 9.54256 8.43406C10.3068 6.76601 8.82403 4.92366 7.02489 5.30595Z"
                          fill="#FFC84F"
                        />
                      </svg>
                    </div>
                  </a>
                  <a
                    href="https://www.youtube.com/ISKCONBHIWANDI"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      className=""
                      style={{
                        backgroundColor: "#B63C40",
                        width: "32px",
                        height: "32px",
                        borderRadius: "16px",
                        display: "flex",
                        justifyContent: "center", // center horizontally
                        alignItems: "center", // center vertically
                      }}
                    >
                      <svg
                        width="17"
                        height="12"
                        viewBox="0 0 17 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.1418 0.358244C15.8733 0.55538 16.4492 1.13621 16.6447 1.87385C17 3.21073 17 6 17 6C17 6 17 8.78924 16.6447 10.1262C16.4492 10.8638 15.8733 11.4446 15.1418 11.6418C13.8161 12 8.50003 12 8.50003 12C8.50003 12 3.18398 12 1.85825 11.6418C1.12681 11.4446 0.55074 10.8638 0.355273 10.1262C0 8.78924 0 6 0 6C0 6 0 3.21073 0.355273 1.87385C0.55074 1.13621 1.12681 0.55538 1.85825 0.358244C3.18398 0 8.50003 0 8.50003 0C8.50003 0 13.8161 0 15.1418 0.358244ZM6.76138 8.53243L11.2046 6.00013L6.76138 3.46754V8.53243Z"
                          fill="#FFC84F"
                        />
                      </svg>
                    </div>
                  </a>
                  <a
                    href="https://facebook.com/iskconbhiwandi"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      style={{
                        backgroundColor: "#B63C40",
                        width: "32px",
                        height: "32px",
                        borderRadius: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        width="9"
                        height="17"
                        viewBox="0 0 9 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 5.50507H5.93591V3.74187C5.93591 3.07752 6.435 2.92311 6.78682 2.92311C7.13864 2.92311 8.95091 2.92311 8.95091 2.92311V0.0107732L5.97273 0C2.66727 0 1.91455 2.17258 1.91455 3.56231V5.50507H0V8.50718H1.91045C1.91045 12.3604 1.91045 17 1.91045 17H5.93182C5.93182 17 5.93182 12.3137 5.93182 8.50718H8.64409L9 5.50507Z"
                          fill="#FFC84F"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="mobile-top-menu d-none">
            <ul className="list-unstyled mb-0">
              {isWatchLive && (
                <li>
                  <Link className="live" to="/watch-live">
                    {" "}
                    <GoDotFill /> Watch Live
                  </Link>
                </li>
              )}
              <li>
                <Link to="/donation-form" onClick={quickDonateBtn}>
                  <svg width="20" height="20" viewBox="0 0 512 512">
                    <g id="#000000ff">
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                      />
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                      />
                    </g>
                  </svg>
                  Quick Donate
                </Link>
              </li>
              <li>
                {token ? (
                  <>
                    <Link to="/dashboard">
                      <HiUser /> <span>Dashboard</span>
                    </Link>
                    <Link onClick={logOut}>
                      <HiOutlineLogout /> <span>Logout</span>
                    </Link>
                  </>
                ) : (
                  <button onClick={() => navigate("/dashboard")}>
                    <HiUser /> <span>Loginn</span>
                  </button>
                )}
              </li>
            </ul>
          </div>

          <div className="top-nav">
            <ul className="social-icons list-unstyled mb-0">
              {isWatchLive && (
                <li className="me-3 d-lg-inline-block d-none">
                  <button onClick={() => navigate("/watch-live")}>
                    <GoDotFill /> <span>Watch Live</span>
                  </button>
                </li>
              )}
              <li>
                {token ? (
                  <>
                    {location?.pathname?.includes("/ics") ? (
                      <span style={{ textTransform: "uppercase" }}>
                        WELCOME {user?.name}{" "}
                      </span>
                    ) : (
                      <span style={{ textTransform: "uppercase" }}>
                        {" "}
                        {!donor ? "" : "WELCOME"} {donor?.legal_name}{" "}
                      </span>
                    )}
                  </>
                ) : (
                  <span> </span>
                )}
              </li>
            </ul>
            <span className="logo">
              <Link to="/">
                <img src="/images/common/logo.png" alt="" />
              </Link>
            </span>

            <ul className="login-wrap list-unstyled mb-0">
              {/* <li className="me-lg-3 d-none d-lg-inline-block">
                <button onClick={quickDonateBtn}>
                  <svg width="20" height="20" viewBox="0 0 512 512">
                    <g id="#000000ff">
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                      />
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                      />
                    </g>
                  </svg>
                  Quick Donate
                </button>
              </li> */}
              <li className="d-lg-none d-block">
                <button
                  className="m-0 pe-2 ps-1 box-hover animation"
                  onClick={handleNavigate}
                >
                  <div className="anination-wrap">
                    <div className="heart">
                      <svg width="24" height="24" viewBox="0 0 512 512">
                        <g id="#000000ff">
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                          />
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="ripple"></div>
                  </div>
                  Donate
                </button>
              </li>
              {token ? (
                <li className="d-lg-none d-block">
                  <button
                    className="m-0 pe-2 ps-1 box-hover animation"
                    onClick={logOut}
                  >
                    <div className="anination-wrap">
                      <HiOutlineLogout />
                    </div>
                    Logout
                  </button>
                </li>
              ) : (
                ""
              )}

              <li className="d-none d-lg-inline-block">
                {token ? (
                  <>
                    <button onClick={() => navigate("/dashboard")}>
                      <HiUser /> <span>Dashboard </span>
                    </button>
                  </>
                ) : (
                  ""
                )}
              </li>
              {/* <li className="d-none d-lg-inline-block">
                {token ? (
                  <>
                    <button className="" onClick={logOut}>
                      <HiOutlineLogout /> <span>Logout</span>
                    </button>
                  </>
                ) : (
                  ""
                )}
              </li> */}
              <li>
                <button
                  className="toggle-side-menu"
                  onClick={() => setOpened(true)}
                >
                  <VscThreeBars />
                </button>
              </li>
            </ul>
          </div>
          <nav>
            <ul className="list-unstyled nav-list">
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/"
                >
                  Home
                </NavLink>
              </li>

              <li className="drop-menu">
                <button
                  className="drop-btn"
                  onClick={() => navigate("/about-us")}
                >
                  About <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/about-us/#mission">ISKCON Mission</Link>
                    </li>
                    <li>
                      <Link to="/about-us/#founder">Founder</Link>
                    </li>
                    <li>
                      <Link to="/about-us/#temple">
                        Sri Sri Radha Madhava Temple
                      </Link>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/daily-darshan-gallery"
                      >
                        Daily Darshan
                      </NavLink>
                    </li>
                    <li>
                      <Link to="/gaudiya-vaishnavism">Gaudiya Vaishnavism</Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="drop-menu">
                <button
                  className="drop-btn"
                  onClick={() => navigate("/services")}
                >
                  Services <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/courses">Courses</Link>
                    </li>
                    <li>
                      <Link to="/services">Services</Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/movement"
                >
                  Hare Krishna Movement
                </NavLink>
              </li>
              <li className="drop-menu">
                <button className="drop-btn">
                  Events <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="redirect-link"
                        href="https://iskcontsp.org/"
                        target="_blank"
                      >
                        Harinam Sankirtan <FiExternalLink />
                      </a>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/festivals"
                      >
                        Festivals
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/yatras"
                      >
                        Yatras
                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/Recent-Events"
                      >
                        Recent Events
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/gallery"
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/classes-video"
                      >
                        Classes Videos
                      </NavLink>
                    </li> */}
                  </ul>
                </div>
              </li>
              <li className="drop-menu">
                <button className="drop-btn">
                  Support us <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive
                            ? "active donate-button-clicked-header-menu"
                            : "donate-button-clicked-header-menu"
                        }
                        to="/donate-categories"
                      >
                        Donate
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/volunteer"
                      >
                        Volunteer
                      </NavLink>
                    </li>
                    <li className="has-submenu">
                      {/* <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to=""
                      >
                        Food For Life
                      </NavLink> */}
                      <span className="anc">
                        Food For Life <AiFillCaretRight />
                      </span>
                      <ul className="mb-0 list-unstyled">
                        <li>
                          <Link to="/about-annadaan">About</Link>
                        </li>
                        <li>
                          <Link to="/annadaan">Donate</Link>
                        </li>
                        {/* <li>
                          <Link to="/Special-Occassion">Special Occassion</Link>
                        </li> */}
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/connect"
                >
                  Connect
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/shop"
                >
                  Shop
                </NavLink>
              </li>
              <li>
                <button
                  className="m-0 px-3 custom-btn-cls box-hover animation donate-button-clicked-header"
                  onClick={handleNavigate}
                >
                  <div className="anination-wrap">
                    <span className="heart">
                      <svg width="24" height="24" viewBox="0 0 512 512">
                        <g id="#000000ff">
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                          />
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                          />
                        </g>
                      </svg>
                    </span>
                    <span className="ripple"></span>
                  </div>
                  Donate
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <Modal centered show={loginPopup} onHide={handleHideModal}>
        <div className="auth-modal">
          <button className="btn close-svg" onClick={handleHideModal}>
            <MdOutlineClose />
          </button>
          <div className="row align-items-center">
            <div className="col-md-6 d-sm-block d-none pe-md-0">
              <div className="popup-left-side">
                <figure className="bg_img">
                  <img src="/images/common/bg-line.jpg" alt="" />
                </figure>
                <div className="left-content">
                  <h4>Login</h4>
                  <div className="main-content">
                    <h3>
                      Log-in to save your details, view donation history and{" "}
                      <span> download 80G certificate </span> conveniently.
                    </h3>
                  </div>
                </div>
                <figure className="popup-img">
                  <img src="/images/modal/hare-krishna-logo.svg" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-md-6 ps-md-0">
              {otpSent ? (
                <div className="pop-up-form">
                  <div className="pop-up-top">
                    <div className="heading">
                      <h2 className="head-2">OTP Verification</h2>
                    </div>
                  </div>
                  <p>
                    Enter the OTP sent to +91 {number} and on your registered
                    mail id.
                  </p>
                  <form action="" className="mt-3 mt-sm-0">
                    <div className="row align-items-center">
                      <div className="col-12">
                        <div className="label-input-wrap">
                          <input
                            type="tel"
                            id="otp"
                            name="otp"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            minLength={6}
                            maxLength={6}
                            placeholder="Enter OTP"
                          />
                        </div>
                        {!showresendlink && showTimer && (
                          <div className="time-wrap">
                            <p className="mb-0">Resend OTP in</p>
                            <span className="timer_span d-inline-block">
                              {getTime(otpExp)}s
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className={`pop-form-btn ${
                        otp.length !== 6 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="box-hover"
                        type="button"
                        onClick={handleLogin}
                      >
                        Verify
                      </button>
                    </div>
                    {showresendlink && (
                      <div className="time-wrap mt-4">
                        <p className="mb-0">Not yet received OTP?</p>
                        <button onClick={resendOtp} type="button">
                          Resend OTP
                        </button>
                      </div>
                    )}
                    <div className="time-wrap mt-4">
                      <p className="mb-0">Change number?</p>
                      <button onClick={() => setOtpSent(false)} type="button">
                        Click here
                      </button>
                    </div>
                  </form>
                </div>
              ) : (
                <div className="pop-up-form">
                  <div className="pop-up-top">
                    <div className="heading">
                      <h2 className="head-2">Login</h2>
                    </div>
                  </div>
                  <p>
                    We will send you an OTP on this mobile number and on your
                    registered mail id.
                  </p>
                  <form action="" className="mt-3 mt-sm-0">
                    <div className="row align-items-center m-0">
                      <div className="col-12 px-0">
                        <div className="label-input-wrap">
                          <input
                            type="tel"
                            id="number"
                            name="number"
                            placeholder="Enter Mobile Number"
                            defaultValue={
                              localStorage.getItem("icsmob")
                                ? localStorage.getItem("icsmob")
                                : number
                            }
                            required
                            onChange={(e) => setNumber(e.target.value)}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            minLength={10}
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`pop-form-btn ${
                        !number || number.length !== 10 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="box-hover"
                        type="button"
                        onClick={() => {
                          handleSendOtp();
                        }}
                        disabled={btnDisabled}
                      >
                        Get OTP
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TopHeader;
